// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__GABeq","iconWrapper":"Logo_iconWrapper__01u9C","text":"Logo_text__3lgjN"};